module.exports = __webpack_public_path__ + "media/images/icons/outlined/insurance-c62f7f0130883c7cbaf687af62693f5d.svg";